<h2 mat-dialog-title>
  Edycja wydatku <strong>({{ data.billerName }})</strong>
</h2>

<form [formGroup]="form" (ngSubmit)="save()">
  <div class="flex flex-col">
    <mat-form-field appearance="outline" [hideRequiredMarker]="true">
      <mat-label>Tytuł</mat-label>
      <div fxFlex="row" fxLayoutAlign="start center">
        <input
          matInput
          [formControl]="form.title"
          [maxlength]="this.appConfig.config.titleMaxLength"
          [appInputMaxLength]="this.appConfig.config.titleMaxLength"
          name="title"
          required
          appGtmFormEvent
          [eventField]="'title'"
          [eventForm]="formName"
        />
        <app-icon
          name="info_outlined"
          size="20"
          matTooltip="Tytuł powinien pozwalać na identyfikację wpłaty przez dostawcę."
        ></app-icon>
      </div>

      <mat-hint align="end">{{ form.title.value.length || '0' }} /{{ this.appConfig.config.titleMaxLength }}</mat-hint>
      <mat-error *ngIf="form.title.errors">
        {{
          form.title.errors.required
            ? 'Pole nie może być puste'
            : form.title.errors.minlength
            ? 'Wartość zbyt krótka'
            : 'Wartość zbyt długa'
        }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" [hideRequiredMarker]="true">
      <mat-label>Kwota</mat-label>
      <input
        matInput
        type="text"
        [formControl]="form.amount"
        placeholder="0,00 zł"
        name="amount"
        appCurrency
        autocomplete="off"
        tabindex="0"
        appGtmFormEvent
        [eventField]="'amount'"
        [eventForm]="formName"
      />
      <mat-error>
        <app-amount-error
          [amount]="form.amount"
          [minAmount]="MIN_AMOUNT"
          [maxAmount]="this.appConfig.config.liabilityAmountLimit"
        ></app-amount-error>
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" [hideRequiredMarker]="true">
      <mat-label>Termin płatności</mat-label>
      <input
        matInput
        appInputDateMask
        required
        [formControl]="form.paymentDue"
        placeholder="DD.MM.YYYY"
        autocomplete="off"
        [min]="minDate"
        [max]="maxDate"
        [matDatepicker]="firstPaymentDatePicker"
        appGtmFormEvent
        [eventField]="'paymentDue'"
        [eventForm]="formName"
      />
      <mat-datepicker-toggle matSuffix [for]="firstPaymentDatePicker"></mat-datepicker-toggle>
      <mat-datepicker #firstPaymentDatePicker [touchUi]="handsetService.isXs"></mat-datepicker>
      <mat-error *ngIf="form.paymentDue.errors?.matDatepickerMin ||  form.paymentDue.errors?.matDatepickerMax">
        Wybierz datę z zakresu {{ minDate | date: isoPattern}} - {{ maxDate | date: isoPattern }}
      </mat-error>

    </mat-form-field>
  </div>

  <mat-dialog-actions align="start">
    <button mat-raised-button type="submit" color="accent" cdkFocusInitial>Zapisz</button>
    <button mat-button matDialogClose>Anuluj</button>
  </mat-dialog-actions>
</form>
